import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";

import {MaterialCommonModule} from "src/app/material-modules/material-common.module";
import {CadastrarEixoComponent} from "./cadastrar-eixo/cadastrar-eixo.component";
import {EixoRoutingModule} from "./eixo-routing.module";
import {EixoComponent} from "./eixo.component";

@NgModule({
    declarations: [EixoComponent, CadastrarEixoComponent],
    imports: [
        CommonModule,
        EixoRoutingModule,
        MaterialCommonModule,
    ],
})
export class EixoModule {
}
